import api from '@/api';

export const PRIORITY_DEADLINES_KEY = 'priority-deadlines';

// fallbacks match the values that were previously hardcoded in
// ChoppingTasks.vue and TaskPanel.vue
export const DEFAULT_PRIORITY_DEADLINES = {
  chopping: {1: '13:00', 2: '14:00', 3: '15:00'},
  components: {1: '09:00', 2: '10:00', 3: '11:00'},
};

export async function fetchPriorityDeadlines() {
  const result = JSON.parse(JSON.stringify(DEFAULT_PRIORITY_DEADLINES));
  try {
    const {data} = await api.get(`v2/settings/${PRIORITY_DEADLINES_KEY}`);
    const value = (data && data.value) || {};
    for (const team of Object.keys(result)) {
      result[team] = {...result[team], ...(value[team] || {})};
    }
  } catch (e) {
    console.error('failed to fetch priority deadlines, using defaults', e);
  }
  return result;
}
